export default __webpack_public_path__ + "static/media/Social-Distancing.eac89f1c.png";